module.exports = __webpack_public_path__ + "media/images/icon_logo-fe3fcdfe65d020f12dd2fa5cb298878a.png";